// CONSTANTS
export const Constants = {
  ALGOLIA_EVENT: 'FIRE_ALGOLIA_EVENT',
  CLIENTSIDE_TRANSITION: 'CLIENTSIDE_TRANSITION_COLLECTION',
  COLLECTION_ACTION_CREATE: 'COLLECTION_ACTION_CREATE',
  // Create a Collection
  COLLECTION_ACTION_DELETE: 'COLLECTION_ACTION_DELETE',
  // Delete
  COLLECTION_ACTION_DUPLICATE: 'COLLECTION_ACTION_DUPLICATE',
  // Duplicate
  COLLECTION_ACTION_EDIT: 'COLLECTION_ACTION_EDIT',
  // Edit
  COLLECTION_ACTION_EXPORT_EMAILS: 'COLLECTION_ACTION_EXPORT_EMAILS',
  // Export Emails
  COLLECTION_ACTION_IOS_VIR: 'COLLECTION_ACTION_IOS_VIR',
  // iOS ViR
  COLLECTION_ACTION_REORDER: 'COLLECTION_ACTION_REORDER',
  // Reorder
  FILTER_EVENT: 'FIRE_FILTER_EVENT',
  PRIVATE_COLLECTION_ERROR: 'PRIVATE_COLLECTION_ERROR',
  UPDATE_ALGOLIA: 'UPDATE_ALGOLIA_COLLECTION',
  UPDATE_HITS_PER_PAGE: 'UPDATE_HITS_PER_PAGE_COLLECTION',
  UPDATE_PAGE: 'UPDATE_PAGE_COLLECTION',
  UPDATE_URL: 'UPDATE_URL_COLLECTION',
}
// ACTION TYPES
export type FlowTypes =
  | {
      type: typeof Constants.ALGOLIA_EVENT
      payload: Record<string, any>
    }
  | {
      type: typeof Constants.COLLECTION_ACTION_CREATE
    }
  | {
      type: typeof Constants.COLLECTION_ACTION_DELETE
    }
  | {
      type: typeof Constants.COLLECTION_ACTION_DUPLICATE
    }
  | {
      type: typeof Constants.COLLECTION_ACTION_EDIT
    }
  | {
      type: typeof Constants.COLLECTION_ACTION_EXPORT_EMAILS
    }
  | {
      type: typeof Constants.COLLECTION_ACTION_IOS_VIR
    }
  | {
      type: typeof Constants.COLLECTION_ACTION_REORDER
    }
  | {
      type: typeof Constants.CLIENTSIDE_TRANSITION
      payload: string
    }
  | {
      type: typeof Constants.FILTER_EVENT
    }
  | {
      type: typeof Constants.PRIVATE_COLLECTION_ERROR
    }
  | {
      type: typeof Constants.UPDATE_ALGOLIA
      payload?: Record<string, any>
    }
  | {
      type: typeof Constants.UPDATE_HITS_PER_PAGE
      payload: number
    }
  | {
      type: typeof Constants.UPDATE_PAGE
      payload: number
    }
  | {
      type: typeof Constants.UPDATE_URL
      payload: string
    }
// ACTION CALLS
export const Actions = {
  ALGOLIA_EVENT: (payload: Record<string, any>): FlowTypes => ({
    type: Constants.ALGOLIA_EVENT,
    payload,
  }),
  COLLECTION_ACTION_CREATE: (): FlowTypes => ({
    type: Constants.COLLECTION_ACTION_CREATE,
  }),
  COLLECTION_ACTION_DELETE: (): FlowTypes => ({
    type: Constants.COLLECTION_ACTION_DELETE,
  }),
  COLLECTION_ACTION_DUPLICATE: (): FlowTypes => ({
    type: Constants.COLLECTION_ACTION_DUPLICATE,
  }),
  COLLECTION_ACTION_EDIT: (): FlowTypes => ({
    type: Constants.COLLECTION_ACTION_EDIT,
  }),
  COLLECTION_ACTION_EXPORT_EMAILS: (): FlowTypes => ({
    type: Constants.COLLECTION_ACTION_EXPORT_EMAILS,
  }),
  COLLECTION_ACTION_IOS_VIR: (): FlowTypes => ({
    type: Constants.COLLECTION_ACTION_IOS_VIR,
  }),
  COLLECTION_ACTION_REORDER: (): FlowTypes => ({
    type: Constants.COLLECTION_ACTION_REORDER,
  }),
  CLIENTSIDE_TRANSITION: (payload: string): FlowTypes => ({
    type: Constants.CLIENTSIDE_TRANSITION,
    payload,
  }),
  FILTER_EVENT: (): FlowTypes => ({
    type: Constants.FILTER_EVENT,
  }),
  PRIVATE_COLLECTION_ERROR: (): FlowTypes => ({
    type: Constants.PRIVATE_COLLECTION_ERROR,
  }),
  UPDATE_ALGOLIA: (payload?: Record<string, any>): FlowTypes => ({
    type: Constants.UPDATE_ALGOLIA,
    payload,
  }),
  UPDATE_HITS_PER_PAGE: (payload: number): FlowTypes => ({
    type: Constants.UPDATE_HITS_PER_PAGE,
    payload,
  }),
  UPDATE_PAGE: (payload: number): FlowTypes => ({
    type: Constants.UPDATE_PAGE,
    payload,
  }),
  UPDATE_URL: (payload?: string): FlowTypes => ({
    type: Constants.UPDATE_URL,
    payload,
  }),
}